import variables from "../Utils/variables.json";

const getApiBaseUrl = (str) => {
    const hostname = window.location.hostname;
    if (hostname === "staging.utdanning.no" || hostname === "localhost") {
        return variables.apistaging;
    }
    else {
        return variables.apiprod;
    }
};

export default getApiBaseUrl;
